export class Editor {
  constructor(difference) {
    this.width = 168
    this.height = 34
    this.top = 10
    this.left = 10
    this.innerElement = "cxEditor"
    // this.content = "<p style='font-size: 24px;font-weight: 600;font-family:默认字体;line-height: 1.4'>请输入文本内容</p>"
    // 上面的模式 转换方式文本的 index.vue 的get方法有  后端保存要报错
    this.content =
      "&lt;p&nbsp;style=&qquot;font-size:&nbsp;24px;&nbsp;font-family:&nbsp;PingFang SC 微软雅黑;&nbsp;line-height:&nbsp;1.4;&qquot;&gt;请输入文本内容&lt;/p&gt;"
    // this.content =
    //   "&lt;p&nbsp;style=&quot;font-size:&nbsp;24px;&nbsp;font-weight:&nbsp;600;&nbsp;font-family:&nbsp;默认字体;&nbsp;line-height:&nbsp;1.4;&quot;&gt;请输入文本内容&lt;/p&gt;"
    this.bgColor = "rgba(255,255,255,0)"
    this.rotate = 0
    this.textPaddingTypeFlag = 2
    this.padding = 0
    this.paddingTop = 0
    this.paddingRight = 0
    this.paddingLeft = 0
    this.paddingBottom = 0
    this.borderTypeFlag = 2
    this.borderRadius = 0
    this.borderTopLeftRadius = 0
    this.borderTopRightRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.borderStyle = "solid" // solid dashed dotted
    this.borderColor = "#000000"
    this.borderWidth = 0
    this.borderIsThemeColor = false
    this.textOverFlowType = "visible"
    // 透明度
    this.opacity = 100
    // 阴影
    this.boxShadowColor = []
    this.boxShadowH = []
    this.boxShadowV = []
    this.boxShadowBlur = []
    this.boxShadowSpread = []
    this.background = []
    this.textLimitLines = 1
    this.updateTimer = 600 // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址

    this.openBlankPage = true
    this.linkUrl = ""
    this.internalLinkName = ""
    this.accessRulers = []
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
